/* eslint import/no-webpack-loader-syntax: off */

import React from 'react';
import ReactDOM from 'react-dom/client';
import MapsApp from './MapsApp';
import './styles.css';

// @ts-ignore
import mapboxgl from '!mapbox-gl'; // or "const mapboxgl = require('mapbox-gl');"

if( !navigator.geolocation){
  alert('Tu navegador no tiene opcion Geolocation');
  throw new Error ('Tu navegador no tiene opcion Geolocation ')
}

 
mapboxgl.accessToken = 'pk.eyJ1IjoiZ2Fib2dhYml0byIsImEiOiJja25ybGducnYwampjMzFvMzJtM3BhZ3lsIn0._JfEmngPETXvFd8KvgOdxg';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <MapsApp />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

